import { makeStyles } from "@material-ui/core"

export default makeStyles((theme) => ({
	root: {
		padding: theme.spacing(2),
		paddingTop: 0,
		paddingBottom: 0,
		"& fieldset legend": {
			float: "none",
		},
		"& textarea": {
			boxShadow: "none",
		},
	},
	eventChartImg: {
		width: "100%",
		height: "auto",
	},
	dividerLine: {
		width: "100%",
		border: `1px solid ${theme.palette.grey[400]}`,
	},
	formActions: {
		display: "flex",
		justifyContent: "flex-end",
		flexDirection: "row",
		width: "100%",
	},
	formActionsBtn: {
		margin: "0.5rem",
		"&:disabled": {
			backgroundColor: "#e0e0e0 !important",
		},
	},
	addBtn: {
		textTransform: "initial",
		fontSize: "14px",
		fontWeight: 500,
		backgroundColor: theme.palette.secondary.dark,
	},
	dateWrapper: {
		display: "flex",
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	},
	date: {
		maxWidth: 180,
		marginRight: 40,
	},
	margin: {
		margin: theme.spacing(2),
	},
	exportOptions: {
		marginTop: theme.spacing(1),
		display: "flex",
		flexDirection: "row",
	},
	printWrapper: {
		padding: theme.spacing(2),
		backgroundColor: theme.palette.grey["300"],
	},
	printInclude: {
		backgroundColor: theme.palette.grey["400"],
	},
	preview: {
		color: theme.palette.grey.D100,
		fontWeight: 500,
		margin: 0,
	},
	margin: {
		margin: theme.spacing(1),
	},
	textField: {
		width: "95%",
		"& .MuiInputLabel-root": {
			backgroundColor: theme.palette.common.white,
		},
	},
}))
